import { InvoiceRow } from '@blisspointmedia/bpm-types/dist/BillingAutomation';

export const PAGE_TITLE = 'Finance';
export const ROW_HEIGHT = 26;
export const HEADER_HEIGHT = 40;

// Approved CIDs and their signed-off Salesforce relationships.
export const APPROVED_RELATIONSHIPS: Record<string, string[]> = {
  augustasportswear: ['Augusta Sportswear - GM - Paid Search'],
  barnesandnoblecollege: ['Barnes & Noble College Booksellers, LLC-SEM'],
  cecilandlou: [
    'Cecil and Lou - Paid Search - 12/1/2025',
    'Cecil and Lou - Paid Social - 12/1/2025'
  ],
  citygrounds: ['City Grounds - GM - Paid Search', 'City Grounds - GM - Paid Social'],
  cpesupply: ['CPE Supply - GM - Paid Search'],
  everythingbutwater: [
    'Everything But Water - Paid Search - 3/1/2025',
    'Everything But Water - Paid Social - 3/1/2025'
  ],
  fashionfabricsclub: [
    'Fashion Fabrics Club - GM - Paid Search',
    'Fashion Fabrics Club - GM - Paid Social'
  ],
  frenchtoast: ['LT Apparel - GM - Paid Search - 9/11/2023'],
  glossier: ['Glossier Inc - Paid Search - 3/1/2026', 'Glossier Inc - Paid Social - 3/1/2026'],
  greatland: ['Greatland Corporation - Paid Search - 10/1/2025'],
  highpointscientific: [
    'HighPoint Scientific - GM - Paid Search',
    'HighPoint Scientific - GM - Paid Social'
  ],
  kanefurniture: ["Kane's Furniture - Paid Search - 1/1/2026"],
  lippert: ['Lippert Components - Commerce Media - 1/2/2026'],
  lobstersports: ['Lobster Sports - GM - Paid Search'],
  malk: ['MALK Organics - Paid Search - 3/30/2026', 'MALK Organics - Paid Social - 3/30/2026'],
  microfibertech: ['Microfiber Tech-Marketplaces'],
  mistercarwash: [
    'Mister Car Wash - Paid Search - 9/15/2025',
    'Mister Car Wash - Paid Social - 9/15/2025'
  ],
  modaoperandi: ['Moda Operandi-3-Paid Search'],
  moonbug: ['Moonbug - Marketplaces - 8/1/2024'],
  myeyedr: ['MyEyeDr - Paid Search - 9/1/2026 - #1', 'MyEyeDr - Paid Social - 9/1/2026 - #1'],
  nalpak: ['Nalpak - GM - Paid Search'],
  nhnglobal: [
    'NHN Global - GM - Paid Search - 1/04/2024',
    'NHN Global - GM - Paid Social - 1/04/2024'
  ],
  niteflirt: ['NiteFlirt - GM - Paid Search-2'],
  officechairsusa: ['Office Chairs USA - GM - Paid Search', 'Office Chairs USA - GM - Paid Social'],
  restaurantequippers: [
    'Restaurant Equippers - Paid Search - 10/1/2025',
    'Restaurant Equippers - Paid Social - 10/1/2025'
  ],
  riddell: ['Riddell - GM - Paid Search'],
  ruzeshoes: ['Ruze Shoes - GM - Paid Search'],
  snipes: ['Snipes USA - Paid Search - 7/6/2026', 'Snipes USA - Paid Social - 7/6/2026'],
  startstop: [
    'HTH Engineering, Inc - GM - Paid Search',
    'HTH Engineering, Inc - GM - Paid Search-2'
  ],
  truewerk: ['Truewerk, Inc. - Paid Search - 1/1/2025', 'Truewerk, Inc. - Paid Social - 1/1/2025'],
  uppababy: ['UPPAbaby - Paid Search - 1/5/2026', 'UPPAbaby - Paid Social - 1/5/2026']
};

export const APPROVED_CIDS = Object.keys(APPROVED_RELATIONSHIPS);

export interface FinanceRow extends InvoiceRow {
  cid: string;
  month: string;
  signedOff: 'Yes' | 'No';
  // The invoice endpoint doesn't return tool data yet, so these stay blank until it does.
  toolUsed: string;
  toolSpend: string;
}
